import { Reducer } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import thunkMiddleware from "redux-thunk";
import rootReducer, { initialConfigState } from "./common/reducers";
import { All } from "./interfaces";
import { initialUiState } from "./common/reducers/ui";
import { initialResultsState } from "./common/reducers/results";
import { initialAppState } from "./common/reducers/appState";
import { initialRouterHistory } from "./common/reducers/routerHistory";

export interface BankFilters {
  cert: string;
  zip: string;
  states: string[];
  eventTypes: string[];
}

export const initialState = {
  appState: initialAppState,
  ui: initialUiState,
  config: initialConfigState,
  results: initialResultsState,
  routerHistory: initialRouterHistory,
};

export const storeCreator = (initState: All) => {
  return configureStore({
    reducer: rootReducer as Reducer,
    preloadedState: initState,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware().concat(thunkMiddleware),
  });
};
